import React, { useState, useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_REWARD_CARDS_BY_ID, GET_REWARD_CARD_PACK_BY_ID } from '../services/graphql';
import { AuthContext } from '../../../services/auth/AuthProvider';

import { Loader, Button } from '@squirrellearningltd/go-pupil-components';
import PrintCard from '../components/PrintCard';
import styles from './RewardPrint.module.scss'

const RewardPrint = ({ existingSelectedPack, packId }) => {
    const { currentUser } = useContext(AuthContext);
    const [ selectedPack, setSelectedPack] = useState(existingSelectedPack)
    const [ packCards, setPackCards ] = useState();
    const { error, loading } = useQuery(GET_REWARD_CARDS_BY_ID, {
        variables: {
             rewardCardPackId: packId
        },
        onCompleted: data => {
            setPackCards(data.rewardCardsById);
        }
    });

    const { data: rewardCardPackData } = useQuery(GET_REWARD_CARD_PACK_BY_ID, {
        variables: {
            rewardCardPackId: packId
        },
        skip: existingSelectedPack,
        onCompleted: (data) => {
            if (data?.rewardCardPackById) {
                setSelectedPack(data.rewardCardPackById)
            }
        }
    });

    if (error) {
        return <p>{error.message}</p>
    }

    return <>
        {packCards &&
            <div className={styles.printContainer}>
                <div className={styles.printHeader}>
                    <div className={styles.printHeaderInner}>
                        <p className="u-m-base-2">If you use the Chrome browser please make sure the <b>Background graphics</b> setting is checked under <b>More settings</b> when printing if you wish to print the cards with their correct background colours displayed. You may need your Teacher or Parent to help with this.</p>
                        <Button onClick={() => window.print()}>Print</Button>
                    </div>
                </div>
                <div className={styles.rewardsWrapper}>
                    {loading ? <Loader /> :
                        !!packCards.length && packCards.map((card, i) => {
                            return (
                                <PrintCard
                                    key={`'card-${card.id}`}
                                    userCard={currentUser.studentRewardCards.find(c => c.rewardCard.id === card.id)}
                                    card={card}
                                    i={i}
                                    selectedPack={selectedPack}
                                />
                            )
                        })
                    }
                </div>
            </div>}
    </>
}

export default RewardPrint;